import { ReactNode } from 'react';
import { useQualtrics } from '@/analytics/qualtrics/hooks/useQualtrics';
import { useQualtricsUserData } from '@/analytics/qualtrics/hooks/useQualtricsUserData';
import env from '@/env';

const QualtricsProviderData = ({ children }: { children: ReactNode }) => {
  useQualtrics();
  useQualtricsUserData();
  return children;
};

export const QualtricsProvider = ({ children }: { children: ReactNode }) =>
  env.VITE_NODE_ENV !== 'development' ? <QualtricsProviderData>{children}</QualtricsProviderData> : children;
